var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParkering = function SvgParkering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeMiterlimit: 10,
    d: "M5.813 4.5v7.875M13.25 1H2.75A1.75 1.75 0 0 0 1 2.75v10.5c0 .967.783 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 15 13.25V2.75A1.75 1.75 0 0 0 13.25 1ZM5.813 4.063h2.926c.92 0 1.663.743 1.663 1.662v1.92c0 .92-.744 1.663-1.663 1.663H5.812z"
  })));
};
export default SvgParkering;